export default "__VITE_ASSET__2538ea44__"